// src/services/supabaseStorage.js
import { createClient } from '@supabase/supabase-js';

// Hardcode the values temporarily to test if it's an environment variable issue
const supabaseUrl = 'https://aubfdxmxxcrsaztnfkgm.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF1YmZkeG14eGNyc2F6dG5ma2dtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzMyNTc5NDIsImV4cCI6MjA0ODgzMzk0Mn0.ApeaSo0Cm4FaXIKcHMgYoLPPwFusCr-2S9GnWTvM7mo';

// Add console logs for debugging
console.log('Initializing Supabase with:', { supabaseUrl, supabaseKey: 'Key exists: ' + !!supabaseKey });

const supabase = createClient(supabaseUrl, supabaseKey);

console.log('Supabase client created');

export const uploadInvoicePDF = async (pdfBlob, invoiceNo) => {
  console.log('Starting PDF upload for invoice:', invoiceNo);
  try {
    const fileName = `INV-${invoiceNo}-${Date.now()}.pdf`;
    
    // Upload to Supabase
    const { data, error } = await supabase.storage
      .from('invoices')
      .upload(`generated/${fileName}`, pdfBlob, {
        contentType: 'application/pdf',
        cacheControl: '3600',
        upsert: true
      });

    if (error) {
      console.error('Supabase upload error:', error);
      throw error;
    }

    console.log('File uploaded successfully:', data);

    // Get public URL
    const { data: { publicUrl } } = supabase.storage
      .from('invoices')
      .getPublicUrl(`generated/${fileName}`);

    console.log('Generated public URL:', publicUrl);

    return {
      filePath: data.path,
      publicUrl
    };
  } catch (error) {
    console.error('Error uploading to Supabase:', error);
    throw error;
  }
};


// Function to upload engineer certificates
export const uploadEngineerCertificate = async (file, invoiceNo, username) => {
  try {
    // Format: CERT-[INVOICE_NO]-[USERNAME]-[DATE].[EXT]
    const fileExt = file.name.substring(file.name.lastIndexOf('.'));
    const fileName = `CERT-${invoiceNo}-${username}-${new Date().toISOString()}${fileExt}`;
    
    const { data, error } = await supabase.storage
      .from('certificates')
      .upload(`uploaded/${fileName}`, file, {
        cacheControl: '3600',
        upsert: false
      });

    if (error) throw error;

    // Get public URL
    const { data: { publicUrl } } = supabase.storage
      .from('certificates')
      .getPublicUrl(`uploaded/${fileName}`);

    return {
      filePath: data.path,
      publicUrl,
      fileName
    };
  } catch (error) {
    console.error('Error uploading certificate to Supabase:', error);
    throw error;
  }
};

// Function to get file URL
export const getFileUrl = (path, bucket = 'invoices') => {
  try {
    const { data: { publicUrl } } = supabase.storage
      .from(bucket)
      .getPublicUrl(path);
    
    return publicUrl;
  } catch (error) {
    console.error('Error getting file URL:', error);
    throw error;
  }
};

// Function to delete file
export const deleteFile = async (path, bucket = 'invoices') => {
  try {
    const { error } = await supabase.storage
      .from(bucket)
      .remove([path]);
      
    if (error) throw error;
    return true;
  } catch (error) {
    console.error('Error deleting file:', error);
    throw error;
  }
};
